import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/posts';

interface HeroSectionProps {
  onSearch: (query: string) => void;
}

const stats = [
  { value: '320+', label: '已收录看点' },
  { value: '5', label: '主题分类' },
  { value: '3 次', label: '每周更新' },
];

export default function HeroSection({ onSearch }: HeroSectionProps) {
  const [value, setValue] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(value.trim());
  };

  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20entertainment%20stage%20with%20warm%20crimson%20and%20amber%20spotlights%20cutting%20through%20atmospheric%20haze%2C%20glowing%20bokeh%20lights%20and%20drifting%20confetti%2C%20dramatic%20cinematic%20mood%2C%20editorial%20poster%20art%2C%20high%20contrast%2C%20no%20text%2C%20no%20people%20faces&width=1600&height=900&seq=gf-hero-01&orientation=landscape"
        alt="黑料看点高能名场面舞台灯光氛围图"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70" />

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-3xl mx-auto text-center gf-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm backdrop-blur-sm">
            <i className="ri-fire-fill text-accent-400" />
            全网热议的精彩片段，这里一次看全
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl text-background-50 leading-[1.15]">
            黑料看点
          </h1>
          <p className="mt-4 font-heading text-xl md:text-3xl text-accent-300">
            精彩片段 · 高能名场面合集
          </p>
          <p className="mt-5 text-sm md:text-base text-background-100/80 leading-7 max-w-2xl mx-auto">
            专为吃瓜网友整理综艺、影视、颁奖礼、体坛与网络热梗里的爆点精华，点开即看名场面高能片段，快速抓住事件核心，不拖沓不注水。
          </p>

          <form onSubmit={handleSubmit} className="mt-8 max-w-xl mx-auto" role="search">
            <div className="flex flex-col sm:flex-row items-stretch gap-2 p-2 rounded-lg bg-background-50/95 backdrop-blur-sm">
              <div className="relative flex-1">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base" />
                <label htmlFor="hero-search" className="sr-only">
                  搜索看点
                </label>
                <input
                  id="hero-search"
                  name="q"
                  type="search"
                  value={value}
                  onChange={(event) => setValue(event.target.value)}
                  placeholder="搜索节目、名场面或热梗关键词"
                  className="w-full pl-9 pr-3 py-3 rounded-md bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
                />
              </div>
              <button
                type="submit"
                className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                搜一搜
              </button>
            </div>
          </form>

          <div className="mt-6 flex flex-wrap justify-center gap-2">
            {categories.map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-background-50/10 border border-background-50/25 text-background-50/90 text-xs md:text-sm hover:bg-background-50/20 transition-colors"
              >
                <i className={category.icon} />
                {category.name}
              </Link>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-xl mx-auto">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-2xl md:text-3xl text-accent-300">{stat.value}</div>
                <div className="mt-1 text-[11px] md:text-xs text-background-100/70 tracking-wide">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}